import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi', // default - only for display purposes
  },
  theme: {
    themes: {
      light: {
        test: '#424242',
        main: '#101B24',
        cardColour: '#1B2C37',
        primary: '#00AF66',
        secondary: '#E3f6EC',
        accent: '#82B1FF',
        error: '#FF9292',
        info: '#9E9E9E',
        success: '#4CAF50',
        warning: '#FFC107',
      }
    }
  }
});
